import { createAction } from "@reduxjs/toolkit";

import type { NautilusDesignerPermissions } from "./shared.ts";

const withPayloadType =
  <T>() =>
  (t: T) => ({ payload: t });

export const setActiveLanguageCodeAction = createAction("SET_ACTIVE_LANGUAGE_CODE", withPayloadType<string>());

export const setPermissions = createAction("SET_PERMISSIONS", withPayloadType<NautilusDesignerPermissions>());

export const setRootNodeParentContextAction = createAction(
  "SET_ROOT_NODE_PARENT_CONTEXT",
  withPayloadType<Record<string, unknown>>(),
);

export type NautilusDesignerAppConfigAction =
  | ReturnType<typeof setActiveLanguageCodeAction>
  | ReturnType<typeof setPermissions>
  | ReturnType<typeof setRootNodeParentContextAction>;
